import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../hooks/useData';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { data: notifications } = useNotifications(user?.id);

    const unreadCount = notifications.filter(n => !n.read).length;

    return (
        <header className="app-header">
            <div className="logo-section">
                <h1 className="app-logo">Facilita<span className="plus"> Pass+</span></h1>
                <span className="subtitle">Seu Guia de Benefícios</span>
            </div>
            <div className="header-actions">
                <button className="icon-btn" onClick={() => navigate('/notifications')}>
                    <Bell size={24} />
                    {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
                </button>
            </div>
        </header>
    );
};


export default Header;
